export enum UserApiRoutes {
  Search = '/users',
  ById = '/users/:id',
  Managers = '/users/retention-managers',
  RetentionAgents = '/users/retention-agents',
  ByRoleName = '/users/role',
  Mine = '/users/mine',
  Roles = '/users/:id/roles',
  UserSession = '/api/user',
  UserById = '/users/:id/masterAgentId',
}
